import { makeStyles, Theme } from "@material-ui/core/styles";
import { Styles } from "@material-ui/styles/withStyles";
import { MinioFileInput, MinioImageInput } from "@tt/ttms-react-core";
import RichTextInput from "ra-input-rich-text";
import * as React from "react";
import {
  Create,
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SelectArrayInput,
  SelectInput,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
} from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";

export const styles: Styles<Theme, any> = {
  description: { maxWidth: 500 },
};

const useStyles = makeStyles(styles);

const VideoCreate = (props) => {
  const classes = useStyles(props);

  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    notify(`video created and confirmation pending`);
    redirect("../anasayfa");
  };

  return (
    <AuthorizedCheck isAdmin={false}>
      <Create {...props} title="Video Create" onSuccess={onSuccess}>
        <SimpleForm>
          <TextInput autoFocus source="title" label="Title" multiline validate={required()} />
          <ReferenceInput label="Category" source="CategoryId" reference="categorys" sort={{ field: "name", order: "ASC" }}>
            <SelectInput optionText="name" validate={required()} />
          </ReferenceInput>
          <ReferenceArrayInput label="Chapter" source="ChapterId" reference="traxchapters" sort={{ field: "chapter", order: "ASC" }} perPage={100}>
            <SelectArrayInput optionText={(choice) => `${choice.chapter} - ${choice.description}`} validate={required()} />
          </ReferenceArrayInput>
          <RichTextInput source="description" label="Description" validate={required()} formClassName={classes.description} multiline />
          <MinioFileInput
            source="videoPath"
            label="Video file"
            accept="video/*"
            validate={required("Video yükleyin ve max. 800mb")}
            maxSize={800000000}
          />
          <MinioImageInput source="thumbnailPath" label="Video poster" accept="image/*" />
        </SimpleForm>
      </Create>
    </AuthorizedCheck>
  );
};

export default VideoCreate;
